import { styled } from '@mui/material';

import { Typography, Chip } from '@mui/material';

export const KPIChipUp = styled(Chip)`
  width: auto;
  display: inline-flex;
  max-width: min-content;
`;
export const KPIChipDown = styled(Chip)`
  width: auto;
  display: inline-flex;
  max-width: min-content;
`;

export const KPIValue = styled(Typography)``;
export const KPIUnit = styled(Typography)``;

export const KPIRow = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: baseline;
  justify-content: flex-start;
  gap: 2%;
  margin-top: 0.5rem;
`;
export const KPIColumn = styled('div', { shouldForwardProp: (prop) => prop !== "display" })<{ display?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: baseline;
  justify-content: flex-start;
  gap: 2%;
  padding-bottom: ${({ display }) => (display ? '2.5rem' : '0')};
  transition: 0.2s;
  position: relative;
  overflow: hidden;
`;

export const KPIChip = styled('div', { shouldForwardProp: (prop) => prop !== "display" })<{ display?: boolean }>`
  transform: ${({ display }) => (display ? 'translateY(0%)' : 'translateY(100%)')};
  opacity: ${({ display }) => (display ? '1' : '0')};
  transition: 0.2s;
  position: absolute;
  bottom: 0;
`;
